(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("dyna-ui-button"), require("dyna-class-name"), require("dyna-animation"), require("dyna-ui-tooltip"), require("dyna-travel-interfaces"), require("dyna-travel-ui-components"), require("dyna-ui-star-rating"));
	else if(typeof define === 'function' && define.amd)
		define("dyna-travel-ui-list-agent-offers", ["react", "dyna-ui-button", "dyna-class-name", "dyna-animation", "dyna-ui-tooltip", "dyna-travel-interfaces", "dyna-travel-ui-components", "dyna-ui-star-rating"], factory);
	else if(typeof exports === 'object')
		exports["dyna-travel-ui-list-agent-offers"] = factory(require("react"), require("dyna-ui-button"), require("dyna-class-name"), require("dyna-animation"), require("dyna-ui-tooltip"), require("dyna-travel-interfaces"), require("dyna-travel-ui-components"), require("dyna-ui-star-rating"));
	else
		root["dyna-travel-ui-list-agent-offers"] = factory(root["react"], root["dyna-ui-button"], root["dyna-class-name"], root["dyna-animation"], root["dyna-ui-tooltip"], root["dyna-travel-interfaces"], root["dyna-travel-ui-components"], root["dyna-ui-star-rating"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_18__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EProduct;
(function (EProduct) {
    EProduct["IM_HOLIDAY"] = "IM_HOLIDAY";
    EProduct["DIE_TO_FLY"] = "DIE_TO_FLY";
})(EProduct = exports.EProduct || (exports.EProduct = {}));


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = __webpack_require__(2);
var dyna_ui_button_1 = __webpack_require__(1);
exports.styleMixer = function (product) {
    switch (product) {
        case interfaces_1.EProduct.DIE_TO_FLY:
            return {
                primaryButtonColor: dyna_ui_button_1.EColor.RED_WHITE,
            };
        case interfaces_1.EProduct.IM_HOLIDAY:
        default:
            return {
                primaryButtonColor: dyna_ui_button_1.EColor.ORANGE_WHITE,
            };
    }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(23);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DynaTravelListAgentOffers_1 = __webpack_require__(9);
exports.DynaTravelListAgentOffers = DynaTravelListAgentOffers_1.DynaTravelListAgentOffers;
var interfaces_1 = __webpack_require__(2);
exports.EProduct = interfaces_1.EProduct;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var dyna_ui_button_1 = __webpack_require__(1);
var dyna_class_name_1 = __webpack_require__(3);
var dyna_animation_1 = __webpack_require__(10);
var interfaces_1 = __webpack_require__(2);
var messages_1 = __webpack_require__(11);
var DynaTripOffer_1 = __webpack_require__(12);
var styleMixer_1 = __webpack_require__(4);
__webpack_require__(24);
var DynaTravelListAgentOffers = /** @class */ (function (_super) {
    __extends(DynaTravelListAgentOffers, _super);
    function DynaTravelListAgentOffers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = dyna_class_name_1.dynaClassName("dyna-travel-list-agent-offers");
        return _this;
    }
    DynaTravelListAgentOffers.prototype.renderProposalsExpiredRibbon = function () {
        var _a = this.props, product = _a.product, proposalsExpired = _a.proposalsExpired, _b = _a.messages, refreshToUpdateThePrice = _b.refreshToUpdateThePrice, refreshTheCurrentPricesAreNotValid = _b.refreshTheCurrentPricesAreNotValid, refreshButton = _b.refreshButton, onRefreshClick = _a.onRefreshClick;
        var className = dyna_class_name_1.dynaClassName(this.className("__proposals-expired-ribbon"));
        return (React.createElement(dyna_animation_1.DynaAnimationVerticalContainer, { show: proposalsExpired },
            React.createElement("div", { className: className() },
                React.createElement("div", { className: className("__icon") },
                    React.createElement("i", { className: "fas fa-exclamation-triangle" })),
                React.createElement("div", { className: className("__content") },
                    React.createElement("div", { className: className("__content__m1") }, refreshToUpdateThePrice),
                    React.createElement("div", { className: className("__content__m2") }, refreshTheCurrentPricesAreNotValid)),
                React.createElement("div", { className: className("__button") },
                    React.createElement(dyna_ui_button_1.DynaButton, { color: styleMixer_1.styleMixer(product).primaryButtonColor, size: dyna_ui_button_1.ESize.XLARGE, ghost: true, onClick: onRefreshClick },
                        React.createElement("span", null,
                            React.createElement("i", { className: "fas fa-sync" }),
                            " ",
                            refreshButton))))));
    };
    DynaTravelListAgentOffers.prototype.render = function () {
        var _a = this.props, product = _a.product, offers = _a.offers, proposalsExpired = _a.proposalsExpired, formatPrice = _a.formatPrice, messages = _a.messages, onOfferClick = _a.onOfferClick;
        return (React.createElement("div", { className: this.className() },
            this.renderProposalsExpiredRibbon(),
            offers.map(function (offer, index) {
                return (React.createElement(DynaTripOffer_1.DynaTripOffer, { key: index, product: product, tripOffer: offer, proposalsExpired: proposalsExpired, formatPrice: formatPrice, messages: messages, onOfferClick: onOfferClick }));
            })));
    };
    DynaTravelListAgentOffers.defaultProps = {
        product: interfaces_1.EProduct.IM_HOLIDAY,
        offers: [],
        proposalsExpired: false,
        formatPrice: function (price) { return price.currency + " " + price.value; },
        messages: messages_1.defaultMessages,
        onOfferClick: function (trip) { return undefined; },
        onRefreshClick: function () { return undefined; },
    };
    return DynaTravelListAgentOffers;
}(React.Component));
exports.DynaTravelListAgentOffers = DynaTravelListAgentOffers;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessages = {
    select: "Select",
    more: "more",
    less: "less",
    agentCompany: "agent",
    airlineCompany: "airline",
    lowCost: "low cost",
    refreshToUpdateThePrice: "Refresh to get the latest prices",
    refreshTheCurrentPricesAreNotValid: "The current prices are no longer valid",
    refreshButton: "Refresh",
    baggageTypeBaggage: "Baggage",
    baggageTypeHandBag: "Hand bag",
    perBag: "per bag",
    noBags: "no bags",
    unknownBags: "no bag info",
    totalMax: "total max weight",
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var dyna_class_name_1 = __webpack_require__(3);
var dyna_svg_1 = __webpack_require__(13);
var dyna_ui_button_1 = __webpack_require__(1);
var dyna_ui_tooltip_1 = __webpack_require__(15);
var dyna_travel_interfaces_1 = __webpack_require__(16);
var dyna_travel_ui_components_1 = __webpack_require__(17);
var dyna_ui_star_rating_1 = __webpack_require__(18);
var styleMixer_1 = __webpack_require__(4);
var airlineCompanyIcon = __webpack_require__(19);
var travelAgentIcon = __webpack_require__(20);
__webpack_require__(21);
var DynaTripOffer = /** @class */ (function (_super) {
    __extends(DynaTripOffer, _super);
    function DynaTripOffer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = dyna_class_name_1.dynaClassName("dtlao-dyna-trip-offer");
        return _this;
    }
    DynaTripOffer.prototype.renderExpiredProposalTooltip = function () {
        var _a = this.props, proposalsExpired = _a.proposalsExpired, refreshToUpdateThePrice = _a.messages.refreshToUpdateThePrice;
        if (proposalsExpired)
            return React.createElement("span", null,
                React.createElement("i", { className: "fas fa-sync" }),
                " ",
                refreshToUpdateThePrice);
        else
            return null;
    };
    DynaTripOffer.prototype.renderCompanyBaggageInfo = function () {
        var _a = this.props, _b = _a.tripOffer, agent = _b.agent, segments = _b.segments, _c = _a.messages, agentCompany = _c.agentCompany, airlineCompany = _c.airlineCompany, lowCost = _c.lowCost, messages = _a.messages;
        var className = dyna_class_name_1.dynaClassName(this.className("__company"));
        return (React.createElement("div", { className: className() },
            React.createElement("div", { className: className("__logo-container") }, !!agent.logoUrl
                ? React.createElement("img", { src: agent.logoUrl })
                : (agent.type === dyna_travel_interfaces_1.EDynaCompanyType.AIRLINE
                    ? React.createElement(dyna_svg_1.DynaSvg, { className: "no-logo", src: airlineCompany })
                    : React.createElement(dyna_svg_1.DynaSvg, { className: "no-logo", src: travelAgentIcon }))),
            React.createElement("div", { className: className("__details-container") },
                agent.iataCode ? React.createElement("div", { className: className("__iata-code") }, agent.iataCode) : null,
                agent.allianceName ? React.createElement("div", { className: className("__alliance-name") }, agent.allianceName) : null,
                React.createElement("div", { className: className("__company-name") },
                    React.createElement("span", null,
                        agent.name.text,
                        " "),
                    agent.type === dyna_travel_interfaces_1.EDynaCompanyType.AGENT ? React.createElement("span", { className: className("__company-type") },
                        React.createElement("i", { className: "fas fa-building" }),
                        " ",
                        agentCompany,
                        " ") : null,
                    agent.type === dyna_travel_interfaces_1.EDynaCompanyType.AIRLINE ? React.createElement("span", { className: className("__company-type") },
                        React.createElement("i", { className: "fas fa-plane" }),
                        " ",
                        airlineCompany,
                        " ") : null,
                    agent.lowCost ? React.createElement("span", { className: className("__low-cost") }, lowCost) : null),
                agent.rate.rates
                    ? React.createElement(dyna_ui_star_rating_1.DynaStarRating, { value: 5 * agent.rate.rate / agent.rate.rates })
                    : null,
                agent.website ? React.createElement("div", { className: className("__website") },
                    React.createElement("i", { className: "fas fa-globe" }),
                    " ",
                    React.createElement("a", { href: agent.website, target: "_blank" }, agent.website)) : null,
                React.createElement(dyna_travel_ui_components_1.BaggageIcon, { height: 24, baggage: segments[0].segments[0].transport.baggage, baggageType: dyna_travel_ui_components_1.EBaggageType.BAGGAGE, messages: messages }),
                "\u00A0",
                React.createElement(dyna_travel_ui_components_1.BaggageIcon, { height: 20, baggage: segments[0].segments[0].transport.handBags, baggageType: dyna_travel_ui_components_1.EBaggageType.HAND_BAG, messages: messages }))));
    };
    DynaTripOffer.prototype.renderPrice = function () {
        var _a = this.props, proposalsExpired = _a.proposalsExpired, price = _a.tripOffer.price, formatPrice = _a.formatPrice;
        return (React.createElement("div", { className: this.className("__price", proposalsExpired && "__price--expired") },
            React.createElement("div", { className: this.className("__price__value") },
                React.createElement(dyna_ui_tooltip_1.DynaTooltip, { tooltipContent: this.renderExpiredProposalTooltip(), tooltipDirection: dyna_ui_tooltip_1.ETooltipDirection.NORTH }, formatPrice(price)))));
    };
    DynaTripOffer.prototype.renderSelectButton = function () {
        var _a = this.props, product = _a.product, tripOffer = _a.tripOffer, proposalsExpired = _a.proposalsExpired, select = _a.messages.select, onOfferClick = _a.onOfferClick;
        return (React.createElement("div", { className: this.className("__select") },
            React.createElement(dyna_ui_tooltip_1.DynaTooltip, { tooltipContent: this.renderExpiredProposalTooltip(), tooltipDirection: dyna_ui_tooltip_1.ETooltipDirection.WEST },
                React.createElement(dyna_ui_button_1.DynaButton, { size: dyna_ui_button_1.ESize.XLARGE, disabled: proposalsExpired, ghost: !proposalsExpired, color: styleMixer_1.styleMixer(product).primaryButtonColor, onClick: function () { return onOfferClick(tripOffer); } },
                    React.createElement("span", null,
                        select,
                        " ",
                        React.createElement("i", { className: "fas fa-chevron-circle-right" }))))));
    };
    DynaTripOffer.prototype.render = function () {
        if (!this.props.tripOffer)
            return null;
        return (React.createElement("div", { className: this.className() },
            React.createElement("div", { className: this.className("__company-wrapper") }, this.renderCompanyBaggageInfo()),
            React.createElement("div", { className: this.className("__price-wrapper") }, this.renderPrice()),
            React.createElement("div", { className: this.className("__select-wrapper") }, this.renderSelectButton())));
    };
    return DynaTripOffer;
}(React.Component));
exports.DynaTripOffer = DynaTripOffer;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(0));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["dyna-svg"] = factory(require("react"));else root["dyna-svg"] = factory(root["react"]);
})(typeof self !== 'undefined' ? self : undefined, function (__WEBPACK_EXTERNAL_MODULE_2__) {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};
			/******/
			/******/ // The require function
			/******/function __webpack_require__(moduleId) {
				/******/
				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId]) {
					/******/return installedModules[moduleId].exports;
					/******/
				}
				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/i: moduleId,
					/******/l: false,
					/******/exports: {}
					/******/ };
				/******/
				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
				/******/
				/******/ // Flag the module as loaded
				/******/module.l = true;
				/******/
				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}
			/******/
			/******/
			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;
			/******/
			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;
			/******/
			/******/ // define getter function for harmony exports
			/******/__webpack_require__.d = function (exports, name, getter) {
				/******/if (!__webpack_require__.o(exports, name)) {
					/******/Object.defineProperty(exports, name, {
						/******/configurable: false,
						/******/enumerable: true,
						/******/get: getter
						/******/ });
					/******/
				}
				/******/
			};
			/******/
			/******/ // getDefaultExport function for compatibility with non-harmony modules
			/******/__webpack_require__.n = function (module) {
				/******/var getter = module && module.__esModule ?
				/******/function getDefault() {
					return module['default'];
				} :
				/******/function getModuleExports() {
					return module;
				};
				/******/__webpack_require__.d(getter, 'a', getter);
				/******/return getter;
				/******/
			};
			/******/
			/******/ // Object.prototype.hasOwnProperty.call
			/******/__webpack_require__.o = function (object, property) {
				return Object.prototype.hasOwnProperty.call(object, property);
			};
			/******/
			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "/dist/";
			/******/
			/******/ // Load entry module and return exports
			/******/return __webpack_require__(__webpack_require__.s = 0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			module.exports = __webpack_require__(1);

			/***/
		},
		/* 1 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			var __extends = this && this.__extends || function () {
				var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
					d.__proto__ = b;
				} || function (d, b) {
					for (var p in b) {
						if (b.hasOwnProperty(p)) d[p] = b[p];
					}
				};
				return function (d, b) {
					extendStatics(d, b);
					function __() {
						this.constructor = d;
					}
					d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
				};
			}();
			var __assign = this && this.__assign || Object.assign || function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s) {
						if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
					}
				}
				return t;
			};
			Object.defineProperty(exports, "__esModule", { value: true });
			var React = __webpack_require__(2);
			__webpack_require__(3);
			var DynaSvg = /** @class */function (_super) {
				__extends(DynaSvg, _super);
				function DynaSvg() {
					return _super !== null && _super.apply(this, arguments) || this;
				}
				DynaSvg.prototype.render = function () {
					var _a = this.props,
					    userClassName = _a.className,
					    src = _a.src,
					    style = _a.style;
					var props = __assign({}, this.props);
					delete props.className;
					delete props.src;
					var className = ['dyna-svg', userClassName, userClassName || style ? '' : 'dyna-svg-defaults'].join(' ').trim();
					return React.createElement("div", __assign({ className: className }, props, { style: __assign({}, style || {}, { display: 'inline-block', fontSize: 0 }), dangerouslySetInnerHTML: { __html: src } }));
				};
				DynaSvg.defaultProps = {
					className: '',
					src: null
				};
				return DynaSvg;
			}(React.Component);
			exports.DynaSvg = DynaSvg;

			/***/
		},
		/* 2 */
		/***/function (module, exports) {

			module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

			/***/
		},
		/* 3 */
		/***/function (module, exports, __webpack_require__) {

			// style-loader: Adds some css to the DOM by adding a <style> tag

			// load the styles
			var content = __webpack_require__(4);
			if (typeof content === 'string') content = [[module.i, content, '']];
			// Prepare cssTransformation
			var transform;

			var options = {};
			options.transform = transform;
			// add the styles to the DOM
			var update = __webpack_require__(6)(content, options);
			if (content.locals) module.exports = content.locals;
			// Hot Module Replacement
			if (false) {
				// When the styles change, update the <style> tags
				if (!content.locals) {
					module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/lib/index.js??ref--4-2!../node_modules/less-loader/dist/cjs.js!./index.less", function () {
						var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/lib/index.js??ref--4-2!../node_modules/less-loader/dist/cjs.js!./index.less");
						if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];
						update(newContent);
					});
				}
				// When the module is disposed, remove the <style> tags
				module.hot.dispose(function () {
					update();
				});
			}

			/***/
		},
		/* 4 */
		/***/function (module, exports, __webpack_require__) {

			exports = module.exports = __webpack_require__(5)(false);
			// imports


			// module
			exports.push([module.i, ".dyna-svg svg {\n  width: inherit;\n  height: inherit;\n}\n.dyna-svg-defaults {\n  width: 63.4477px;\n}\n", ""]);

			// exports


			/***/
		},
		/* 5 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			/*
   	MIT License http://www.opensource.org/licenses/mit-license.php
   	Author Tobias Koppers @sokra
   */
			// css base code, injected by the css-loader

			module.exports = function (useSourceMap) {
				var list = [];

				// return the list of modules as css string
				list.toString = function toString() {
					return this.map(function (item) {
						var content = cssWithMappingToString(item, useSourceMap);
						if (item[2]) {
							return "@media " + item[2] + "{" + content + "}";
						} else {
							return content;
						}
					}).join("");
				};

				// import a list of modules into the list
				list.i = function (modules, mediaQuery) {
					if (typeof modules === "string") modules = [[null, modules, ""]];
					var alreadyImportedModules = {};
					for (var i = 0; i < this.length; i++) {
						var id = this[i][0];
						if (typeof id === "number") alreadyImportedModules[id] = true;
					}
					for (i = 0; i < modules.length; i++) {
						var item = modules[i];
						// skip already imported module
						// this implementation is not 100% perfect for weird media query combinations
						//  when a module is imported multiple times with different media queries.
						//  I hope this will never occur (Hey this way we have smaller bundles)
						if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
							if (mediaQuery && !item[2]) {
								item[2] = mediaQuery;
							} else if (mediaQuery) {
								item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
							}
							list.push(item);
						}
					}
				};
				return list;
			};

			function cssWithMappingToString(item, useSourceMap) {
				var content = item[1] || '';
				var cssMapping = item[3];
				if (!cssMapping) {
					return content;
				}

				if (useSourceMap && typeof btoa === 'function') {
					var sourceMapping = toComment(cssMapping);
					var sourceURLs = cssMapping.sources.map(function (source) {
						return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
					});

					return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
				}

				return [content].join('\n');
			}

			// Adapted from convert-source-map (MIT)
			function toComment(sourceMap) {
				// eslint-disable-next-line no-undef
				var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
				var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

				return '/*# ' + data + ' */';
			}

			/***/
		},
		/* 6 */
		/***/function (module, exports, __webpack_require__) {

			/*
   	MIT License http://www.opensource.org/licenses/mit-license.php
   	Author Tobias Koppers @sokra
   */

			var stylesInDom = {};

			var memoize = function memoize(fn) {
				var memo;

				return function () {
					if (typeof memo === "undefined") memo = fn.apply(this, arguments);
					return memo;
				};
			};

			var isOldIE = memoize(function () {
				// Test for IE <= 9 as proposed by Browserhacks
				// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
				// Tests for existence of standard globals is to allow style-loader
				// to operate correctly into non-standard environments
				// @see https://github.com/webpack-contrib/style-loader/issues/177
				return window && document && document.all && !window.atob;
			});

			var getElement = function (fn) {
				var memo = {};

				return function (selector) {
					if (typeof memo[selector] === "undefined") {
						memo[selector] = fn.call(this, selector);
					}

					return memo[selector];
				};
			}(function (target) {
				return document.querySelector(target);
			});

			var singleton = null;
			var singletonCounter = 0;
			var stylesInsertedAtTop = [];

			var fixUrls = __webpack_require__(7);

			module.exports = function (list, options) {
				if (typeof DEBUG !== "undefined" && DEBUG) {
					if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
				}

				options = options || {};

				options.attrs = _typeof(options.attrs) === "object" ? options.attrs : {};

				// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
				// tags it will allow on a page
				if (!options.singleton) options.singleton = isOldIE();

				// By default, add <style> tags to the <head> element
				if (!options.insertInto) options.insertInto = "head";

				// By default, add <style> tags to the bottom of the target
				if (!options.insertAt) options.insertAt = "bottom";

				var styles = listToStyles(list, options);

				addStylesToDom(styles, options);

				return function update(newList) {
					var mayRemove = [];

					for (var i = 0; i < styles.length; i++) {
						var item = styles[i];
						var domStyle = stylesInDom[item.id];

						domStyle.refs--;
						mayRemove.push(domStyle);
					}

					if (newList) {
						var newStyles = listToStyles(newList, options);
						addStylesToDom(newStyles, options);
					}

					for (var i = 0; i < mayRemove.length; i++) {
						var domStyle = mayRemove[i];

						if (domStyle.refs === 0) {
							for (var j = 0; j < domStyle.parts.length; j++) {
								domStyle.parts[j]();
							}delete stylesInDom[domStyle.id];
						}
					}
				};
			};

			function addStylesToDom(styles, options) {
				for (var i = 0; i < styles.length; i++) {
					var item = styles[i];
					var domStyle = stylesInDom[item.id];

					if (domStyle) {
						domStyle.refs++;

						for (var j = 0; j < domStyle.parts.length; j++) {
							domStyle.parts[j](item.parts[j]);
						}

						for (; j < item.parts.length; j++) {
							domStyle.parts.push(addStyle(item.parts[j], options));
						}
					} else {
						var parts = [];

						for (var j = 0; j < item.parts.length; j++) {
							parts.push(addStyle(item.parts[j], options));
						}

						stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
					}
				}
			}

			function listToStyles(list, options) {
				var styles = [];
				var newStyles = {};

				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					var id = options.base ? item[0] + options.base : item[0];
					var css = item[1];
					var media = item[2];
					var sourceMap = item[3];
					var part = { css: css, media: media, sourceMap: sourceMap };

					if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
				}

				return styles;
			}

			function insertStyleElement(options, style) {
				var target = getElement(options.insertInto);

				if (!target) {
					throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
				}

				var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

				if (options.insertAt === "top") {
					if (!lastStyleElementInsertedAtTop) {
						target.insertBefore(style, target.firstChild);
					} else if (lastStyleElementInsertedAtTop.nextSibling) {
						target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
					} else {
						target.appendChild(style);
					}
					stylesInsertedAtTop.push(style);
				} else if (options.insertAt === "bottom") {
					target.appendChild(style);
				} else {
					throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
				}
			}

			function removeStyleElement(style) {
				if (style.parentNode === null) return false;
				style.parentNode.removeChild(style);

				var idx = stylesInsertedAtTop.indexOf(style);
				if (idx >= 0) {
					stylesInsertedAtTop.splice(idx, 1);
				}
			}

			function createStyleElement(options) {
				var style = document.createElement("style");

				options.attrs.type = "text/css";

				addAttrs(style, options.attrs);
				insertStyleElement(options, style);

				return style;
			}

			function createLinkElement(options) {
				var link = document.createElement("link");

				options.attrs.type = "text/css";
				options.attrs.rel = "stylesheet";

				addAttrs(link, options.attrs);
				insertStyleElement(options, link);

				return link;
			}

			function addAttrs(el, attrs) {
				Object.keys(attrs).forEach(function (key) {
					el.setAttribute(key, attrs[key]);
				});
			}

			function addStyle(obj, options) {
				var style, update, remove, result;

				// If a transform function was defined, run it on the css
				if (options.transform && obj.css) {
					result = options.transform(obj.css);

					if (result) {
						// If transform returns a value, use that instead of the original css.
						// This allows running runtime transformations on the css.
						obj.css = result;
					} else {
						// If the transform function returns a falsy value, don't add this css.
						// This allows conditional loading of css
						return function () {
							// noop
						};
					}
				}

				if (options.singleton) {
					var styleIndex = singletonCounter++;

					style = singleton || (singleton = createStyleElement(options));

					update = applyToSingletonTag.bind(null, style, styleIndex, false);
					remove = applyToSingletonTag.bind(null, style, styleIndex, true);
				} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
					style = createLinkElement(options);
					update = updateLink.bind(null, style, options);
					remove = function remove() {
						removeStyleElement(style);

						if (style.href) URL.revokeObjectURL(style.href);
					};
				} else {
					style = createStyleElement(options);
					update = applyToTag.bind(null, style);
					remove = function remove() {
						removeStyleElement(style);
					};
				}

				update(obj);

				return function updateStyle(newObj) {
					if (newObj) {
						if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
							return;
						}

						update(obj = newObj);
					} else {
						remove();
					}
				};
			}

			var replaceText = function () {
				var textStore = [];

				return function (index, replacement) {
					textStore[index] = replacement;

					return textStore.filter(Boolean).join('\n');
				};
			}();

			function applyToSingletonTag(style, index, remove, obj) {
				var css = remove ? "" : obj.css;

				if (style.styleSheet) {
					style.styleSheet.cssText = replaceText(index, css);
				} else {
					var cssNode = document.createTextNode(css);
					var childNodes = style.childNodes;

					if (childNodes[index]) style.removeChild(childNodes[index]);

					if (childNodes.length) {
						style.insertBefore(cssNode, childNodes[index]);
					} else {
						style.appendChild(cssNode);
					}
				}
			}

			function applyToTag(style, obj) {
				var css = obj.css;
				var media = obj.media;

				if (media) {
					style.setAttribute("media", media);
				}

				if (style.styleSheet) {
					style.styleSheet.cssText = css;
				} else {
					while (style.firstChild) {
						style.removeChild(style.firstChild);
					}

					style.appendChild(document.createTextNode(css));
				}
			}

			function updateLink(link, options, obj) {
				var css = obj.css;
				var sourceMap = obj.sourceMap;

				/*
    	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
    	and there is no publicPath defined then lets turn convertToAbsoluteUrls
    	on by default.  Otherwise default to the convertToAbsoluteUrls option
    	directly
    */
				var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

				if (options.convertToAbsoluteUrls || autoFixUrls) {
					css = fixUrls(css);
				}

				if (sourceMap) {
					// http://stackoverflow.com/a/26603875
					css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
				}

				var blob = new Blob([css], { type: "text/css" });

				var oldSrc = link.href;

				link.href = URL.createObjectURL(blob);

				if (oldSrc) URL.revokeObjectURL(oldSrc);
			}

			/***/
		},
		/* 7 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			/**
    * When source maps are enabled, `style-loader` uses a link element with a data-uri to
    * embed the css on the page. This breaks all relative urls because now they are relative to a
    * bundle instead of the current page.
    *
    * One solution is to only use full urls, but that may be impossible.
    *
    * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
    *
    * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
    *
    */

			module.exports = function (css) {
				// get current location
				var location = typeof window !== "undefined" && window.location;

				if (!location) {
					throw new Error("fixUrls requires window.location");
				}

				// blank or null?
				if (!css || typeof css !== "string") {
					return css;
				}

				var baseUrl = location.protocol + "//" + location.host;
				var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

				// convert each url(...)
				/*
    This regular expression is just a way to recursively match brackets within
    a string.
    	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
       (  = Start a capturing group
         (?:  = Start a non-capturing group
             [^)(]  = Match anything that isn't a parentheses
             |  = OR
             \(  = Match a start parentheses
                 (?:  = Start another non-capturing groups
                     [^)(]+  = Match anything that isn't a parentheses
                     |  = OR
                     \(  = Match a start parentheses
                         [^)(]*  = Match anything that isn't a parentheses
                     \)  = Match a end parentheses
                 )  = End Group
                 *\) = Match anything and then a close parens
             )  = Close non-capturing group
             *  = Match anything
          )  = Close capturing group
     \)  = Match a close parens
    	 /gi  = Get all matches, not the first.  Be case insensitive.
     */
				var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
					// strip quotes (if they exist)
					var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
						return $1;
					}).replace(/^'(.*)'$/, function (o, $1) {
						return $1;
					});

					// already a full url? no change
					if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
						return fullMatch;
					}

					// convert the url to a full url
					var newUrl;

					if (unquotedOrigUrl.indexOf("//") === 0) {
						//TODO: should we add protocol?
						newUrl = unquotedOrigUrl;
					} else if (unquotedOrigUrl.indexOf("/") === 0) {
						// path should be relative to the base url
						newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
					} else {
						// path should be relative to current directory
						newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
					}

					// send back the fixed url(...)
					return "url(" + JSON.stringify(newUrl) + ")";
				});

				// send back the fixed css
				return fixedCss;
			};

			/***/
		}]
		/******/)
	);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 100 100\" x=\"0px\" y=\"0px\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.53,51.88A43.4,43.4,0, 0,1,86.1,23.4a16,16,0,0,0-5.53,3.51l-5.44,5.36L59.35,28.86a14.71,14.71,0,0,0-7.39.31,14.55,14.55,0,0,0-5.42,3l-3.68,3.24a10.26,10.26,0,0,0,.84,16.07,14.41,14.41,0,0,0-2.31,1.67l-1.7,1.5A10.23,10.23,0,0,0,37.32,67L22.11,79.39A43.24,43.24,0,0,1,5.53,51.88Zm8.24,45.24a18.37,18.37,0,0,0,2.45.79l.33.08c.31.08.61.15.88.2l.35.06c.3.06.61.11.88.14a20.7,20.7,0,0,0,5.13.05l.88-.13a20.52,20.52,0,0,0,8.66-3.58L51.5,81l-2.06-5.4L44,72.65,27.12,86.41a10.24,10.24,0,0,1-4.68,2,10.85,10.85,0,0,1-2.66.08l-.33,0-.29,0-.42-.08-.26-.05A9,9,0,0,1,17.2,88a10.57,10.57,0,0,1-6.83-7.61A51.71,51.71,0,0,1,2.87,70,18.93,18.93,0,0,0,2,72.28,20,20,0,0,0,5.61,91.22,20.19,20.19,0,0,0,13.76,97.12ZM97.18,33.43a7.27,7.27,0,0,0-10.57-.38l-8.75,8.61-20.32-4.4a6.08,6.08,0,0,0-5.29,1.38l-3.68,3.24a1.65,1.65,0,0,0,.27,2.67l16.43,9.49-5.63,5.54-7.76-1.33a5.72,5.72,0,0,0-4.77,1.35l-1.71,1.51a1.65,1.65,0,0,0,.31,2.7l10.63,5.69,4.3,11.27a1.65,1.65,0,0,0,2.64.65L65,79.92a5.72,5.72,0,0,0,1.94-4.56l-.35-8,6.12-4.82L80,80a1.66,1.66,0,0,0,2,.94,1.66,1.66,0,0,0,.61-.34l3.68-3.24a6.08,6.08,0,0,0, 2-5.07l-1.8-20.71L96.22,44a7.28,7.28,0,0,0,1-10.54Z\"></path></svg>"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\"><g><path d=\"M38.892,65.637l3.672,30.438L29.729,77.961c-4.701,6.035-9.333,10.953-12.963,13.915l0.98,8.124l-4.173-5.889 c-1.497,0.832-2.642,1.061-3.306,0.57c-0.676-0.5-0.786-1.692-0.407-3.412l-7.087-2.342l8.361-1.498 c1.771-4.276,5.033-9.986,9.292-16.081L0,64.602l29.222-5.236c6.217-8.219,11.183-13.549,15.059-10.684 C48.067,51.481,44.679,57.568,38.892,65.637z M89.364,42.331c0.478,2.464,0.731,5.007,0.735,7.608 c0.033,22.147-17.893,40.127-40.04,40.16c-1.799,0.003-3.57-0.115-5.308-0.342l-1.237-10.26c1.195,1.141,2.526,2.303,3.816,3.211 v-8.795c-1.49,0.111-2.963,0.322-4.415,0.623l-0.641-5.314c1.651-0.322,3.338-0.544,5.056-0.656V57.671 c2.469-5.272,1.481-8.339,0-10.12V32.629c-4.008-0.264-7.855-1.115-11.457-2.471c-0.746,1.323-5.082,9.773-5.125,17.529h4.921 c-2.456,2-5.069,5.055-8.088,8.995l-1.706,0.306c-0.2-1.304-0.345-2.625-0.433-3.963h-9.762c0.167,1.922,0.494,3.799,0.963,5.617 l-5.574,0.999c-0.758-3.069-1.165-6.278-1.17-9.581C9.867,27.913,27.794,9.934,49.94,9.9c2.884-0.005,5.698,0.299,8.411,0.873 c-1.364,2.83-2.177,5.977-2.302,9.299c-1.379-1.237-2.646-2.246-3.38-2.781v9.99c1.374-0.104,2.732-0.289,4.073-0.553 c0.446,1.771,1.094,3.464,1.917,5.051c-1.948,0.428-3.948,0.716-5.99,0.85v15.059H69.25c-0.087-2.074-0.393-4.098-0.813-5.992 c1.809,0.971,3.759,1.713,5.812,2.185c0.168,1.254,0.286,2.523,0.35,3.808h9.776c-0.081-1.227-0.229-2.434-0.436-3.622 C85.838,43.705,87.656,43.117,89.364,42.331z M31,27.939c-1.633-0.879-3.195-1.871-4.682-2.961 c-6.11,5.785-10.101,13.783-10.692,22.709h9.776C25.757,40.553,27.746,33.848,31,27.939z M39.076,17.316 c-3.019,1.009-5.851,2.422-8.433,4.179c1.035,0.694,2.104,1.337,3.209,1.917C35.413,21.229,37.165,19.191,39.076,17.316z M47.331,17.291c-1.695,1.236-5.33,4.32-8.441,8.279c2.729,0.922,5.553,1.494,8.441,1.711V17.291z M52.669,68.566 c3.798,0.248,7.45,1.025,10.885,2.26c3.741-5.543,5.331-13.407,5.653-17.801H52.669V68.566z M60.363,75.383 c-2.496-0.779-5.068-1.271-7.694-1.469v8.795C55.889,80.471,59.461,76.499,60.363,75.383z M68.44,79.105 c-0.948-0.594-1.924-1.146-2.929-1.647c-1.395,1.857-2.932,3.603-4.586,5.226C63.591,81.793,66.111,80.585,68.44,79.105z M84.319,53.025h-9.763c-0.473,7.24-2.627,14.02-6.078,19.954c1.555,0.808,3.046,1.717,4.472,2.714 C79.305,70.014,83.537,62.014,84.319,53.025z M72.421,29.215c0,1.037,0,5.931,0,9.074c0.505,0.211,1.019,0.4,1.543,0.569V27.478 C73.964,27.478,72.421,27.559,72.421,29.215z M100,19.91c0,6.17-2.807,11.683-7.211,15.334v-7.139 c0-4.896-4.746-8.865-9.644-8.865l-6.112-0.002c-4.896,0-9.643,3.971-9.643,8.867v7.139c-4.404-3.651-7.211-9.164-7.211-15.334 C60.18,8.914,69.094,0,80.09,0S100,8.914,100,19.91z M87.588,10.671c0-4.142-3.357-7.499-7.499-7.499s-7.499,3.357-7.499,7.499 s3.357,7.499,7.499,7.499S87.588,14.813,87.588,10.671z M86.216,27.478c0,0,0,7.528-0.001,11.381 c0.525-0.169,1.04-0.358,1.544-0.569c0-3.15,0-8.059,0-9.074C87.759,27.593,86.216,27.478,86.216,27.478z\"></path></g></svg>"

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(22);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--4-2!../../node_modules/less-loader/dist/cjs.js!./DynaTripOffer.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--4-2!../../node_modules/less-loader/dist/cjs.js!./DynaTripOffer.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".dtlao-dyna-trip-offer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  -webkit-transition: background-color 250ms ease-in-out;\n  transition: background-color 250ms ease-in-out;\n}\n@media (max-width: 768px) {\n  .dtlao-dyna-trip-offer {\n    display: block;\n  }\n}\n.dtlao-dyna-trip-offer:hover {\n  background: lightgray;\n}\n.dtlao-dyna-trip-offer__company-wrapper {\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto;\n}\n.dtlao-dyna-trip-offer__price-wrapper {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.dtlao-dyna-trip-offer__select-wrapper {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.dtlao-dyna-trip-offer__company {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.dtlao-dyna-trip-offer__company__logo-container {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0;\n          flex: 1 0;\n  min-width: 160px;\n  max-width: 160px;\n  width: 160px;\n  padding-right: 16px;\n}\n.dtlao-dyna-trip-offer__company__logo-container img {\n  width: 100%;\n}\n.dtlao-dyna-trip-offer__company__logo-container .no-logo {\n  display: block !important;\n  height: 40px;\n  fill: gray;\n  text-align: center;\n  background-color: #e8e8e8;\n}\n.dtlao-dyna-trip-offer__company__details-container {\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto;\n}\n.dtlao-dyna-trip-offer__company__iata-code {\n  font-size: 32px;\n  font-weight: bold;\n}\n.dtlao-dyna-trip-offer__company__alliance-name {\n  color: #0054a1;\n  font-size: 26px;\n  font-weight: bold;\n}\n.dtlao-dyna-trip-offer__company__company-name {\n  font-size: 21px;\n  font-weight: bold;\n}\n.dtlao-dyna-trip-offer__company__low-cost {\n  font-size: 12px;\n  font-weight: bold;\n}\n.dtlao-dyna-trip-offer__company__company-type {\n  font-size: 14px;\n  color: gray;\n}\n.dtlao-dyna-trip-offer__company__website a {\n  font-family: \"Courier New\";\n  font-size: 14px;\n}\n.dtlao-dyna-trip-offer__company__show-hide-button {\n  display: inline-block;\n  cursor: pointer;\n  color: #0088ff;\n}\n.dtlao-dyna-trip-offer__price {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 0 24px;\n  font-size: 28px;\n  font-weight: bold;\n}\n@media (max-width: 768px) {\n  .dtlao-dyna-trip-offer__price {\n    margin: 0 8px;\n  }\n}\n@media (max-width: 768px) {\n  .dtlao-dyna-trip-offer__price__value {\n    text-align: right;\n    width: 100%;\n  }\n}\n.dtlao-dyna-trip-offer__price--expired {\n  color: #a0a0a0;\n}\n.dtlao-dyna-trip-offer__select {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-right: 4px;\n}\n@media (max-width: 768px) {\n  .dtlao-dyna-trip-offer__select {\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(25);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/lib/index.js??ref--4-2!../node_modules/less-loader/dist/cjs.js!./DynaTravelListAgentOffers.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/lib/index.js??ref--4-2!../node_modules/less-loader/dist/cjs.js!./DynaTravelListAgentOffers.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".dyna-travel-list-agent-offers .dyna-animation-vertical-height-container__content {\n  padding-bottom: 1px;\n}\n.dyna-travel-list-agent-offers__proposals-expired-ribbon {\n  margin: 8px;\n  border: 4px solid gray;\n  padding: 8px;\n  border-radius: 4px;\n  text-align: center;\n}\n@media (min-width: 768px) {\n  .dyna-travel-list-agent-offers__proposals-expired-ribbon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    text-align: left;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n  }\n}\n.dyna-travel-list-agent-offers__proposals-expired-ribbon__icon {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0;\n          flex: 0 0;\n  color: orange;\n  font-size: 24px;\n}\n@media (min-width: 768px) {\n  .dyna-travel-list-agent-offers__proposals-expired-ribbon__icon {\n    margin: 0 24px;\n  }\n}\n.dyna-travel-list-agent-offers__proposals-expired-ribbon__content {\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto;\n  margin: 8px;\n  font-size: 16px;\n}\n.dyna-travel-list-agent-offers__proposals-expired-ribbon__content__m1 {\n  font-weight: bold;\n}\n.dyna-travel-list-agent-offers__proposals-expired-ribbon__content__m2 {\n  font-size: 14px;\n  font-style: italic;\n  color: gray;\n}\n.dyna-travel-list-agent-offers__proposals-expired-ribbon__button {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0;\n          flex: 0 0;\n  white-space: nowrap;\n}\n", ""]);

// exports


/***/ })
/******/ ]);
});